import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Repeat } from "lucide-react";

export default function RecurrenceSection({ formData, onChange }) {
  return (
    <div className="space-y-4 p-4 bg-slate-50 rounded-xl">
      <div className="flex items-center gap-2">
        <Checkbox
          id="is_recurring"
          checked={formData.is_recurring}
          onCheckedChange={(checked) => onChange({ ...formData, is_recurring: checked })}
        />
        <Label htmlFor="is_recurring" className="flex items-center gap-2 cursor-pointer">
          <Repeat className="w-4 h-4 text-slate-500" />
          <span>Gjentakende oppgave</span>
        </Label>
      </div>

      {formData.is_recurring && (
        <div className="grid grid-cols-2 gap-4 pt-2">
          <div className="space-y-2">
            <Label htmlFor="recurrence_pattern">Gjenta hver</Label>
            <Select
              value={formData.recurrence_pattern || "weekly"}
              onValueChange={(v) => onChange({ ...formData, recurrence_pattern: v })}
            >
              <SelectTrigger className="h-9">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="daily">Dag</SelectItem>
                <SelectItem value="weekly">Uke</SelectItem>
                <SelectItem value="monthly">Måned</SelectItem>
                <SelectItem value="yearly">År</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="recurrence_interval">Intervall</Label>
            <Input
              id="recurrence_interval"
              type="number"
              min="1"
              value={formData.recurrence_interval || 1}
              onChange={(e) => onChange({ ...formData, recurrence_interval: parseInt(e.target.value) })}
              className="h-9"
            />
          </div>

          <div className="space-y-2 col-span-2">
            <Label htmlFor="recurrence_end_date">Slutt dato (valgfritt)</Label>
            <Input
              id="recurrence_end_date"
              type="date"
              value={formData.recurrence_end_date || ""}
              onChange={(e) => onChange({ ...formData, recurrence_end_date: e.target.value })}
              className="h-9"
            />
          </div>
        </div>
      )}
    </div>
  );
}